/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { KTSVG } from '../../helpers'
import { Dropdown1 } from '../content/dropdown/Dropdown1'
import { getCSS, getCSSVariableValue } from '../../assets/ts/_utils'
import { useThemeMode } from '../layout/theme-mode/ThemeModeProvider'
import { channel } from 'diagnostics_channel'
import * as Yup from 'yup'
import { useState } from 'react'
import { LanguageHelp, getConfig } from '../../../_metronic/helpers/LanguageHelper'
import { Formik, FieldArray, useFormik, Form, Field, FieldProps } from 'formik'
import { addOrUpdateChannel, deleteChannel } from '../../../app/modules/auth/core/_requests';
import { toast } from 'react-toastify'
import { toAbsoluteUrl } from '../../helpers'
import { formatDate, getChannelImageUrl, parseDateTimeFormat, Select2Option } from '../../../_metronic/helpers/utility'
import * as authHelper from '../../../app/modules/auth/core/AuthHelpers'
import clsx from 'clsx'
import { useChannelRequest } from '../../../app/modules/apps/artificial-intelligence/review-list/core/ChannelRequestProvider'
import { DeleteChannelModal } from '../../../_metronic/partials'
import CreatableSelect from "react-select/creatable"
import makeAnimated from 'react-select/animated'
import DatePicker, { registerLocale } from "react-datepicker";
import "../../../styles/react-datepicker.css";
import { tr } from "date-fns/locale/tr";

const animatedComponents = makeAnimated();
type ChannelCustomField = { key: string; value: string }

const whatsappDefaultCustomFieldList: ChannelCustomField[] = [
  { key: 'WhatsappVerifyToken', value: '' },
  { key: 'WhatsappAccessToken', value: '' },
  { key: 'WhatsappPhoneNumberId', value: '' },
  { key: 'WhatsappBusinessAccountId', value: '' },
  { key: 'WhatsappAppSecret', value: '' },
  { key: 'ChatbotEnabled', value: 'true' },
  { key: 'UseCustomPrompt', value: 'false' },
  { key: 'ChatbotSystemPrompt', value: LanguageHelp('You are a chatbot; give short and focused answers.') },
];

const twitterDefaultCustomFieldList: ChannelCustomField[] = [
  { key: 'TwitterConsumerKey', value: '' },
  { key: 'TwitterConsumerSecretKey', value: '' },
  { key: 'TwitterAccessToken', value: '' },
  { key: 'TwitterAccessTokenSecret', value: '' },
  { key: 'TwitterWebhookEnviromentName', value: '' },
  { key: 'ChatbotEnabled', value: 'true' },
  { key: 'UseCustomPrompt', value: 'false' },
  { key: 'ChatbotSystemPrompt', value: LanguageHelp('You are a chatbot; give short and focused answers.') },
];

const facebookDefaultCustomFieldList: ChannelCustomField[] = [
  { key: 'FacebookVerifyToken', value: '' },
  { key: 'FacebookPageId', value: '' },
  { key: 'FacebookPageAccessToken', value: '' },
  { key: 'FacebookAppSecret', value: '' },
  { key: 'ChatbotEnabled', value: 'true' },
  { key: 'UseCustomPrompt', value: 'false' },
  { key: 'ChatbotSystemPrompt', value: LanguageHelp('You are a chatbot; give short and focused answers.') },
];

const instagramDefaultCustomFieldList: ChannelCustomField[] = [
  { key: 'InstagramVerifyToken', value: '' },
  { key: 'InstagramBusinessAccountId', value: '' },
  { key: 'InstagramPageAccessToken', value: '' },
  { key: 'InstagramAppSecret', value: '' },
  { key: 'ChatbotEnabled', value: 'true' },
  { key: 'UseCustomPrompt', value: 'false' },
  { key: 'ChatbotSystemPrompt', value: LanguageHelp('You are a chatbot; give short and focused answers.') },
];

const normalizeChannelCustomFields = (fields?: ChannelCustomField[]): ChannelCustomField[] => {
  const normalized = [
    ...whatsappDefaultCustomFieldList.map(q => ({ ...q })),
    ...twitterDefaultCustomFieldList.map(q => ({ ...q })),
    ...facebookDefaultCustomFieldList.map(q => ({ ...q })),
    ...instagramDefaultCustomFieldList.map(q => ({ ...q })),
  ];

  (fields ?? [])
    .filter(field => field?.key !== 'WhatsappVerifyToken' && field?.key !== 'FacebookVerifyToken' && field?.key !== 'InstagramVerifyToken') // VerifyToken'i gönderme
    .forEach((field) => {
      if (!field?.key) return
      const index = normalized.findIndex(q => q.key === field.key)
      if (index >= 0) {
        normalized[index] = { ...normalized[index], value: field.value ?? '' }
      } else {
        normalized.push({ key: field.key, value: field.value ?? '' })
      }
    })

  return normalized
}

const getCustomFieldValue = (fields: ChannelCustomField[] | undefined, key: string, fallback = ''): string => {
  const customField = normalizeChannelCustomFields(fields).find(q => q.key === key)
  return customField?.value ?? fallback
}

const setCustomFieldValue = (fields: ChannelCustomField[] | undefined, key: string, value: string): ChannelCustomField[] => {
return normalizeChannelCustomFields(fields).map(q => q.key === key ? { ...q, value } : q)
}

const getCustomFieldIndex = (fields: ChannelCustomField[] | undefined, key: string): number => {
  return normalizeChannelCustomFields(fields).findIndex(q => q.key === key)
}

const removeChannelVerifyTokenField = (fields?: ChannelCustomField[]): ChannelCustomField[] => {
  return (fields ?? []).filter(field =>
    field?.key !== 'WhatsappVerifyToken' &&
    field?.key !== 'FacebookVerifyToken' &&
    field?.key !== 'InstagramVerifyToken'
  )
}

const upsertChannelCustomField = (fields: ChannelCustomField[] | undefined, key: string, value: string): ChannelCustomField[] => {
  const list = [...(fields ?? [])]
  const index = list.findIndex(field => field?.key === key)
  if (index >= 0) {
    list[index] = { key, value }
  } else {
    list.push({ key, value })
  }

  return list
}

const getChannelCustomFieldValue = (fields: ChannelCustomField[] | undefined, key: string, fallback = ''): string => {
  const customField = (fields ?? []).find(q => q?.key === key)
  return customField?.value ?? fallback
}

const setChannelCustomFieldValue = (fields: ChannelCustomField[] | undefined, key: string, value: string): ChannelCustomField[] => {
  return upsertChannelCustomField(fields, key, value)
}

type Props = {
  id: string
  channel?: ChannelFormDto
  functionDelete?: any
}

function getColor(color: string) {
  return "#" + color;
}

export class ChannelFormDto { type = 1; channelName = ""; searchQuery = ""; searchQueryList: object[] = []; searchQueryExceptionList: object[] = []; channelCustomFieldList: { key: string; value: string }[] = []; id = ""; isAutoSearch = false; isAutoAnalysis = true; companyId = ""; searchUrl = ""; expirationTime = "1 month"; token = ""; tokenExpirationDate = new Date(); dataRetrievalStartDate = new Date(); language = ""; isCompetitor = false; competitorName = ""; isGetAccountSharings = false; isGetAccountSharingsComments = false; }

export const isConversationChannelType = (type: number) => type >= 100 && type <= 109

export const isConversationReviewAnalysisChannelType = (type: number) => type === 6 || isConversationChannelType(type)

const ChannelForm: React.FC<Props> = ({ id, channel = new ChannelFormDto(), functionDelete }) => {

  const lang = getConfig()

  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const [loading, setLoading] = useState(false)
  const [collapse, setCollapse] = useState(false)
  const [channelForEdit, updateChannelForEdit] = useState(channel)

  // Track per-field touched state for WhatsApp fields
  const [whatsappTouched, setWhatsappTouched] = useState<{ [key: string]: boolean }>({})

  const [optionsSearchQueryList, updateOptionsSearchQueryList] = React.useState([] as Select2Option[]);
  useEffect(() => {
    if (localStorage) {
      const lsValue: string | null = localStorage.getItem("optionsSearchQueryList_Key")
      if (lsValue) {
        try {
          const options: [Select2Option] = JSON.parse(lsValue) as [Select2Option]
          if (options) {

            updateOptionsSearchQueryList(options);
          }
        } catch (error) {
          console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
        }
      }
    }
    if (lang.selectedLang == "tr") {
      registerLocale("tr-TR", tr);
    }
  }, []);
  useEffect(() => {
    if (Number(channelForEdit.type) === 107 && (!channelForEdit.channelCustomFieldList || channelForEdit.channelCustomFieldList.length === 0)) {
      updateChannelForEdit({
        ...channelForEdit,
        channelCustomFieldList: normalizeChannelCustomFields(channelForEdit.channelCustomFieldList),
      })
    }
  }, [channelForEdit.type]);
  // WhatsApp için özel zorunlu alan kontrolü
  const editChannelSchema = Yup.object().shape({
    channelName: Yup.string()
      .min(3, LanguageHelp('Minimum 3 symbols'))
      .max(50, LanguageHelp('Maximum 50 symbols'))
      .required(LanguageHelp('Channel name is required')),
    competitorName: Yup.string().when('isCompetitor',
      (isCompetitor, schema) => {
        if (isCompetitor == true) {
          return schema
            .min(3, LanguageHelp('Minimum 3 symbols'))
            .max(50, LanguageHelp('Maximum 50 symbols'))
            .required(LanguageHelp('Competitor name is required'))
        } else {
          return schema;
        }
      }),
    type: Yup.string()
      .required(LanguageHelp('Channel type is required')),
    searchUrl: Yup.string().when('type',
      (type, schema) => {
        if (type == 3 || type == 5) { // 10:Sikayetvar, 5:Ekşi
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .url(LanguageHelp('The text you enter must be the url'))
            .required(LanguageHelp('Search url is required'))
        } else {
          return schema;
        }
      }),
    searchQuery: Yup.string().when('type',
      (type, schema) => {
        if (type == 2) { // 2:Twitter
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .matches("^[a-zA-Z0-9_]*$", LanguageHelp("Your username can only contain letters, numbers and \"_\""))
            .required(LanguageHelp('Twitter username is required'))
        }
        else if (type == 8) { // 8:Youtube
          // return schema.min(24, LanguageHelp('Must be exactly 24 digits')).max(24, LanguageHelp('Must be exactly 24 digits'))
          return schema.test({
            name: 'valid-or-ignored',
            message: LanguageHelp('Must be exactly 24 digits'),
            test: function (value: string | any[]) {
              if (!value) return true;
              const lower = value.toString().toLowerCase();
              if (['bulunamadi', 'bulunamadı', 'none', 'no', 'not exist', 'notexist', 'yok', 'na', 'n/a', 'N/A'].includes(lower)) return true;
              return value.length === 24;
            },
          });
        }
        else if (type == 9) { // 9:Reddit
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .max(21, LanguageHelp('Maximum 21 symbols'))
            .matches("^[a-zA-Z0-9_]*$", LanguageHelp('Subreddit name is wrong'))
          // .required(LanguageHelp('Subreddit name is required'))
        }
        else if (type == 20) { // 20:News
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .required(LanguageHelp('Text is required'))
        }
        else if (type == 26) { // 26:Facebook_Comments
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .matches("^[a-zA-Z0-9_.]*$", LanguageHelp("Your username can only contain letters, numbers, \".\" and \"_\""))
            .required(LanguageHelp('Facebook username is required'))
        }
        else if (type == 10) { // 10:Instagram_Comments
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .matches("^[a-z0-9_.]*$", LanguageHelp("Your username can only contain lowercase letters, numbers, \".\" and \"_\""))
            .required(LanguageHelp('Instagram username is required'))
        }
        else if (type == 14) { // 2:Linkedin_Comments
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .matches(/^[a-z0-9ğüşöçİĞÜŞÖÇi̇_-]*$/, LanguageHelp("Your username can only contain lowercase letters, numbers, \"_\" and \"-\""))
            .required(LanguageHelp('Linkedin username is required'))
        }
        else {
          return schema;
        }
      }),
    searchQueryList: Yup.array().when('type',
      (type, schema) => {
        if (type == 2 || type == 9 || type == 11 || type == 13) { // 2:Twitter, 9:Reddit, 11:TikTok_Mentions, 13:Linkedin_Mentions
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
            // Rest of your amenities object properties
          }))
        }
        else if (type == 7) { // 7:Instagram_Comments
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols')).matches(/^#/, LanguageHelp("starts with #"))
            // Rest of your amenities object properties
          }))
        }
        else {
          return schema;
        }
      }),
    searchQueryExceptionList: Yup.array().when('type',
      (type, schema) => {
        if (type == 2) { // 2:Twitter
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
              .matches(/^[a-zA-Z0-9_.]*$/, LanguageHelp("Your username can only contain lowercase letters, uppercase letters, numbers, \".\" and \"_\""))
            // Rest of your amenities object properties
          }))
        }
        else if (type == 27 || type == 28) { // 27:Facebook_Comments 28:Facebook_Sharing
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
              .matches(/^[a-zA-Z0-9_.]*$/, LanguageHelp("Your username can only contain lowercase letters, uppercase letters, numbers, \".\" and \"_\""))
            // Rest of your amenities object properties
          }))
        }
        else if (type == 7 || type == 11) { // 7:Instagram_Comments 11:Instagram_Sharing
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
              .matches(/^[a-zA-Z0-9_.]*$/, LanguageHelp("Your username can only contain lowercase letters, uppercase letters, numbers, \".\" and \"_\""))
            // Rest of your amenities object properties
          }))
        }
        else if (type == 13) { // 13:Linkedin_Mentions
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
              .matches(/^[a-z0-9ğüşöçİĞÜŞÖÇi̇_-]*$/, LanguageHelp("Your username can only contain lowercase letters, numbers, \"_\" and \"-\""))
            // Rest of your amenities object properties
          }))
        }
        else {
          return schema;
        }
      }),
    searchHashtagList: Yup.array().when('type',
      (type, schema) => {
        if (type == 7 || type == 26) { // 7:Instagram_Mentions, 26:Facebook_Mentions
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols')).matches(/^#/, LanguageHelp("starts with #"))
            // Rest of your amenities object properties
          }))
        } else {
          return schema;
        }
      }),

    // Required custom fields
    channelCustomFieldList: Yup.array().when('type', (type, schema) => {
      const channelType = Array.isArray(type) ? Number(type[0]) : Number(type)
      // Chatbot required fields (type 6)
      if (channelType === 6) {
        return schema.test('chatbot-required-fields', function (this: Yup.TestContext, value: unknown) {
          if (!Array.isArray(value)) return this.createError({ message: LanguageHelp('Eksik alan(lar) var!') });
          const enabledField = value.find(f => f.key === 'ChatbotEnabled');
          const isEnabled = enabledField && (enabledField.value === true || enabledField.value === 'true');
          // Required fields for chatbot
          const requiredFields = [
            { key: 'WidgetBotName', label: LanguageHelp('Bot Name') },
            { key: 'WidgetSubtitle', label: LanguageHelp('Subtitle') },
            { key: 'WidgetImage', label: LanguageHelp('Avatar Image URL') },
            // { key: 'WidgetLocale', label: LanguageHelp('Language') },
            // { key: 'WidgetPosition', label: LanguageHelp('Widget Position') },
            // { key: 'WidgetBrandColor', label: LanguageHelp('Brand Color') },
          ];
          const missing = requiredFields.filter(({ key }) => {
            const found = value.find(f => f.key === key && f.value && f.value.trim() !== '');
            return !found;
          });
          if (missing.length > 0) {
            const missingLabels = missing.map(m => m.label).join(', ');
            return this.createError({ message: LanguageHelp('Zorunlu alan(lar) eksik: ') + missingLabels });
          }
          if (isEnabled) {
            const systemPrompt = value.find(f => f.key === 'ChatbotSystemPrompt' && f.value && f.value.trim() !== '');
            if (!systemPrompt) {
              return this.createError({ message: LanguageHelp('Chatbot sistem mesajı zorunludur!') });
            }
          }
          return true;
        });
      }
      if (channelType === 107) {
        return schema.test('whatsapp-required-fields', function (this: Yup.TestContext, value: unknown) {
          if (!Array.isArray(value)) return this.createError({ message: LanguageHelp('Eksik alan(lar) var!') });
          const requiredKeys = [
            { key: 'WhatsappAccessToken', label: "WhatsApp Erişim Token'ı" },
            { key: 'WhatsappPhoneNumberId', label: 'WhatsApp Telefon Numarası Id' },
            { key: 'WhatsappBusinessAccountId', label: 'WhatsApp İşletme Hesabı Id (WABA)' },
            { key: 'WhatsappAppSecret', label: 'WhatsApp App Secret' }
          ];
          const missing = requiredKeys.filter(({ key }) => {
            const found = value.find(f => f.key === key && f.value && f.value.trim() !== '');
            return !found;
          });
          if (missing.length > 0) {
            const missingLabels = missing.map(m => m.label).join(', ');
            return this.createError({ message: LanguageHelp(`Required field(s) are missing: `) + `${missingLabels}` });
          }
          return true;
        });
      }
      if (channelType === 106) {
        return schema.test('facebook-required-fields', function (this: Yup.TestContext, value: unknown) {
          if (!Array.isArray(value)) return this.createError({ message: LanguageHelp('Eksik alan(lar) var!') });
          const requiredKeys = [
            { key: 'FacebookPageId', label: 'Facebook Page ID' },
            { key: 'FacebookPageAccessToken', label: 'Facebook Page Access Token' },
            { key: 'FacebookAppSecret', label: 'Facebook App Secret' }
          ];
          const missing = requiredKeys.filter(({ key }) => {
            const found = value.find(f => f.key === key && f.value && f.value.trim() !== '');
            return !found;
          });
          if (missing.length > 0) {
            const missingLabels = missing.map(m => m.label).join(', ');
            return this.createError({ message: LanguageHelp(`Required field(s) are missing: `) + `${missingLabels}` });
          }
          return true;
        });
      }
      if (channelType === 105) {
        return schema.test('instagram-required-fields', function (this: Yup.TestContext, value: unknown) {
          if (!Array.isArray(value)) return this.createError({ message: LanguageHelp('Eksik alan(lar) var!') });
          const requiredKeys = [
            { key: 'InstagramBusinessAccountId', label: 'Instagram Business Account ID' },
            { key: 'InstagramPageAccessToken', label: 'Instagram Page Access Token' },
            { key: 'InstagramAppSecret', label: 'Instagram App Secret' }
          ];
          const missing = requiredKeys.filter(({ key }) => {
            const found = value.find(f => f.key === key && f.value && f.value.trim() !== '');
            return !found;
          });
          if (missing.length > 0) {
            const missingLabels = missing.map(m => m.label).join(', ');
            return this.createError({ message: LanguageHelp(`Required field(s) are missing: `) + `${missingLabels}` });
          }
          return true;
        });
      }
      if (Number(type) === 104) {
        return schema.test('twitter-required-fields', function (this: Yup.TestContext, value: unknown) {
          if (!Array.isArray(value)) return this.createError({ message: LanguageHelp('Eksik alan(lar) var!') });
          const requiredKeys = [
            { key: 'TwitterConsumerKey', label: "Twitter Consumer Key" },
            { key: 'TwitterConsumerSecretKey', label: "Twitter API Secret" },
            { key: 'TwitterAccessToken', label: "Twitter Access Token" },
            { key: 'TwitterAccessTokenSecret', label: "Twitter Access Token Secret" },
            { key: 'TwitterWebhookEnviromentName', label: "Twitter Webhook Enviroment Name" }
          ];
          const missing = requiredKeys.filter(({ key }) => {
            const found = value.find(f => f && typeof f === 'object' && 'key' in f && f.key === key && typeof f.value === 'string' && f.value.trim() !== '');
            return !found;
          });
          if (missing.length > 0) {
            const missingLabels = missing.map(m => m.label).join(', ');
            return this.createError({ message: LanguageHelp(`Required field(s) are missing: `) + `${missingLabels}` });
          }
          return true;
        });
      }
      return schema;
    }),
  })
  let url = getChannelImageUrl(channel.type);

  const formik = useFormik({
    initialValues: channelForEdit,
    enableReinitialize: true,
    validationSchema: editChannelSchema,
    validateOnMount: true,
    onSubmit: async (values) => {
      if ((values.isGetAccountSharings || values.isGetAccountSharingsComments) && (values.searchQuery == null || values.searchQuery == undefined || values.searchQuery == "")) {
        toast.error(LanguageHelp('Without entering a username, posts or comments related to the account cannot be retrieved!'));
      } else {

        setLoading(true)
        try {
          let preparedCustomFieldList = Number(values.type) === 107
            ? normalizeChannelCustomFields(values.channelCustomFieldList)
            : [...(values.channelCustomFieldList ?? [])]

          const preparedValues = {
            ...values,
            channelCustomFieldList: preparedCustomFieldList,
          }

          var queryList: string[] = []
          preparedValues.searchQueryList.forEach(searchQuery => {
            queryList.push(Object(searchQuery)['label'])
          });
          var queryExceptionList: string[] = []
          preparedValues.searchQueryExceptionList.forEach(searchQueryException => {
            queryExceptionList.push(Object(searchQueryException)['label'])
          });
          const sanitizedCustomFieldList = (Number(preparedValues.type) === 107 || Number(preparedValues.type) === 106 || Number(preparedValues.type) === 105)
            ? removeChannelVerifyTokenField(preparedValues.channelCustomFieldList)
            : preparedValues.channelCustomFieldList
          var addOrUpdateChannelResult = await addOrUpdateChannel(preparedValues.id, preparedValues.channelName, preparedValues.companyId, preparedValues.searchQuery, preparedValues.type, preparedValues.searchUrl, preparedValues.isAutoSearch, queryList, queryExceptionList, preparedValues.expirationTime, preparedValues.dataRetrievalStartDate, preparedValues.language, preparedValues.isCompetitor, preparedValues.competitorName, preparedValues.isGetAccountSharings, preparedValues.isGetAccountSharingsComments, sanitizedCustomFieldList, preparedValues.isAutoAnalysis)

          updateChannelForEdit({
            ...preparedValues,
            channelCustomFieldList: sanitizedCustomFieldList,
            token: addOrUpdateChannelResult.data.result.token,
            tokenExpirationDate: addOrUpdateChannelResult.data.result.tokenExpirationDate,
          })

          setLoading(false)

          if (addOrUpdateChannelResult.data.httpStatusCode === 400) {
            console.error(addOrUpdateChannelResult.data.message)
          }
          else {
            toast.success(LanguageHelp("The channel has been successfully updated."))
          }

        } catch (error) {
          console.error(error)
          setLoading(false)
        }
      }
    },
  })

  const getCustomFieldTouchedPath = (key: string): string => {
    const index = getCustomFieldIndex(formik.values.channelCustomFieldList, key)
    return index >= 0 ? `channelCustomFieldList[${index}].value` : 'channelCustomFieldList'
  }

  // If the touched array is undefined, return false (it may be the initial load).
  const isCustomFieldTouched = (key: string): boolean => {
    const touchedList = formik.touched.channelCustomFieldList;
    if (!touchedList) return false;
    const index = getCustomFieldIndex(formik.values.channelCustomFieldList, key);
    if (index < 0 || !Array.isArray(touchedList)) return false;
    const touchedEntry = touchedList[index];
    if (typeof touchedEntry === 'boolean') return touchedEntry;
    if (touchedEntry && typeof touchedEntry === 'object' && 'value' in touchedEntry) {
      return Boolean((touchedEntry as { value?: boolean }).value);
    }
    return false;
  }

  const chatbotSupportedChannelTypes = [6, 104, 105, 106, 107]

  const getPromptFieldValue = (mode: 'custom' | 'channel', key: string, fallback = ''): string => {
    return mode === 'custom'
      ? getCustomFieldValue(formik.values.channelCustomFieldList, key, fallback)
      : getChannelCustomFieldValue(formik.values.channelCustomFieldList, key, fallback)
  }

  const setPromptFieldList = (mode: 'custom' | 'channel', key: string, value: string): ChannelCustomField[] => {
    return mode === 'custom'
      ? setCustomFieldValue(formik.values.channelCustomFieldList, key, value)
      : setChannelCustomFieldValue(formik.values.channelCustomFieldList, key, value)
  }

  const renderCommonChatbotPromptSection = (mode: 'custom' | 'channel', showPromptValidation = false) => {
    if (!chatbotSupportedChannelTypes.includes(Number(formik.values.type))) {
      return null
    }

    const isChatbotEnabled = getPromptFieldValue(mode, 'ChatbotEnabled', 'true').toLowerCase() !== 'false'
    const isCustomPromptEnabled = getPromptFieldValue(mode, 'UseCustomPrompt', 'false').toLowerCase() === 'true'
    const isGlobalPromptMissing = !window?.AISenseUsChatbotPrompt || window.AISenseUsChatbotPrompt.trim() === ''

    return (
      <>
        <div className='row mb-6'>
          <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Chatbot Active')}</label>
          <div className='col-lg-8 fv-row d-flex align-items-center'>
            <div className='form-check form-switch form-check-custom form-check-solid'>
              <input
                className='form-check-input'
                type='checkbox'
                checked={isChatbotEnabled}
                onChange={(e) => formik.setFieldValue('channelCustomFieldList', setPromptFieldList(mode, 'ChatbotEnabled', e.target.checked ? 'true' : 'false'))}
              />
            </div>
          </div>
        </div>

        {isChatbotEnabled && (
          <>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Channel Based Prompt')}</label>
              <div className='col-lg-8 fv-row d-flex align-items-center'>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    checked={isCustomPromptEnabled}
                    onChange={(e) => formik.setFieldValue('channelCustomFieldList', setPromptFieldList(mode, 'UseCustomPrompt', e.target.checked ? 'true' : 'false'))}
                  />
                </div>
              </div>
            </div>

            {!isCustomPromptEnabled && !isGlobalPromptMissing && (
              <div className='alert alert-success p-3 mb-4'>
                {LanguageHelp('If Channel-Based Prompt is disabled, the system uses the prompt defined in the general Chatbot settings.')}
              </div>
            )}

            {!isCustomPromptEnabled && isGlobalPromptMissing && (
              <div className='alert alert-danger p-3 mb-4'>
                {LanguageHelp('If you want to use Channel-Based Prompt, you must first define a system prompt in the general Chatbot settings.')}<br />
                <a href='/crafted/chatbot-settings' className='btn btn-sm btn-danger mt-2'>{LanguageHelp('Go to Chatbot Settings')}</a>
              </div>
            )}

            {isCustomPromptEnabled && (
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Chatbot System Prompt')}</label>
                <div className='col-lg-8 fv-row'>
                  <textarea
                    className='form-control form-control-lg form-control-solid'
                    rows={4}
                    placeholder={LanguageHelp('System prompt for chatbot')}
                    value={getPromptFieldValue(mode, 'ChatbotSystemPrompt')}
                    onChange={(e) => formik.setFieldValue('channelCustomFieldList', setPromptFieldList(mode, 'ChatbotSystemPrompt', e.target.value))}
                    disabled={isGlobalPromptMissing}
                  />
                  {showPromptValidation && isCustomFieldTouched('ChatbotSystemPrompt') && !getPromptFieldValue(mode, 'ChatbotSystemPrompt') && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </>
    )
  }
  
  return (
    <div>
      <div key={"mainDiv" + channel.id} className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target={'#kt_account_profile_details' + channel.id}
          aria-expanded='true'
          aria-controls={'kt_account_profile_details' + channel.id}
          onClick={(e) => { setCollapse(!collapse) }}
        >
          <div className='d-flex align-items-center'>
            {/* begin:: Avatar */}
            <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
              <a href='#'>
                <div className='symbol-label'>
                  <img src={toAbsoluteUrl(url)} className='w-100' />
                </div>
              </a>
            </div>
            <div className='card-title m-0'>
              <h3 className='fw-bolder m-0'>{formik.values.channelName}</h3>

            </div>

          </div>
          <div className='btn btn-sm btn-icon btn-active-color-primary align-self-end mb-5'>
            {collapse && (
              <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-1' />
            )}
            {!collapse && (
              <KTSVG path='/media/icons/duotune/arrows/arr073.svg' className='svg-icon-1' />
            )}
          </div>

        </div>

        <div id={'kt_account_profile_details' + channel.id} className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className={'card-body border-top p-9'}>

              {/* begin::Input group */}
              <div className='fv-row mb-7'>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Channel Name')}</label>
                  <div className='col-lg-8 fv-row'>
                    <input
                      placeholder={LanguageHelp('Channel Name')}
                      {...formik.getFieldProps('channelName')}
                      type='text'
                      name='channelName'
                      className={clsx('form-control form-control-lg form-control-solid')}
                      autoComplete='off'
                      disabled={formik.isSubmitting}
                    />
                    {formik.touched.channelName && formik.errors.channelName && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.channelName}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* end::Input group */}

              <div id='kt_modal_add_user_scroll' data-kt-scroll='true' >
                {(channel.type === 2) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Blocked Twitter Usernames')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several username(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryExceptionList')}
                            onChange={(searchQueryExceptionList) => formik.setFieldValue('searchQueryExceptionList', searchQueryExceptionList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryExceptionList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("You must add at least one username to block the search. You must enter your own username. Usernames must be at least 3 letters and contain only lowercase letters, numbers and _")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Texts to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            options={optionsSearchQueryList}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several text(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}

                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The texts to be searched must be at least one, and the number of letters of the texts must be at least 3.")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }

                {(formik.values.type == 26) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Blocked Facebook Usernames')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several username(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryExceptionList')}
                            onChange={(searchQueryExceptionList) => formik.setFieldValue('searchQueryExceptionList', searchQueryExceptionList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryExceptionList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("You must add at least one username to block the search. You must enter your own username. Usernames must be at least 3 letters and contain only lowercase letters, numbers and _")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Hashtag to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            options={optionsSearchQueryList}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several hashtag(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The hashtags to be searched must be at least one, and the number of letters of the hashtags must be at least 3. Hashtags must be start with '#' character")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {(formik.values.type == 7) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Blocked Instagram Usernames')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several username(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryExceptionList')}
                            onChange={(searchQueryExceptionList) => formik.setFieldValue('searchQueryExceptionList', searchQueryExceptionList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryExceptionList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("You must add at least one username to block the search. You must enter your own username. Usernames must be at least 3 letters and contain only lowercase letters, numbers and _")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Hashtag to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}

                            isSearchable={true}
                            options={optionsSearchQueryList}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several hashtag(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The hashtags to be searched must be at least one, and the number of letters of the hashtags must be at least 3. Hashtags must be start with '#' character")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {(channel.type === 13) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Blocked Linkedin Usernames')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several username(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryExceptionList')}
                            onChange={(searchQueryExceptionList) => formik.setFieldValue('searchQueryExceptionList', searchQueryExceptionList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryExceptionList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("You must add at least one username to block the search. You must enter your own username. Usernames must be at least 3 letters and contain only lowercase letters, numbers and -")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Texts to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            options={optionsSearchQueryList}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several text(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}

                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The texts to be searched must be at least one, and the number of letters of the texts must be at least 3.")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }

                {((channel.type === 13) || (channel.type === 14)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Linkedin Username')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Linkedin Username')}
                          {...formik.getFieldProps('searchQuery')}
                        />
                        {formik.touched.searchQuery && formik.errors.searchQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }

                {(formik.values.type == 1) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Expiration Date')}</label>
                      <label className='col-lg-8 col-form-label fv-row'>
                        {formatDate(channelForEdit.tokenExpirationDate, lang.selectedLang)}
                      </label>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('New Expiration Time')}</label>
                      <div className='col-lg-8 fv-row'>
                        <select
                          className='form-select form-select-solid form-select-lg'
                          {...formik.getFieldProps('expirationTime')}
                          onChange={formik.handleChange}
                        >
                          <option value=''>{LanguageHelp('Select a time to update the expiration date')}</option>
                          <option value='limitless'>{LanguageHelp('Limitless')}</option>
                          <option value='1 month'>{LanguageHelp('1 month')}</option>
                          <option value='3 month'>{LanguageHelp('3 month')}</option>
                          <option value='6 month'>{LanguageHelp('6 month')}</option>
                          <option value='1 year'>{LanguageHelp('1 year')}</option>
                          <option value='2 year'>{LanguageHelp('2 year')}</option>
                          <option value='3 year'>{LanguageHelp('3 year')}</option>
                        </select>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Token')}</label>
                      <label className='col-lg-8 col-form-label fv-row'>
                        {channelForEdit.token}
                      </label>
                    </div>
                    <div className='row mb-6'>
                      <div className='notice d-flex bg-light-success rounded border-warning border border-dashed mb-6 p-6'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen044.svg'
                          className='svg-icon-2tx svg-icon-success me-4'
                        />

                        <div className='d-flex flex-stack flex-grow-1'>
                          <div className='fw-bold'>
                            <div className='fs-6 text-gray-600'>
                              {LanguageHelp('Click on the link to access the commands of the API, try it on the site or download it as a collection for postman.')}
                              <a href='https://aiapi.aisenseus.net' target='_blank' className='text-gray-800 text-hover-primary' >
                                &nbsp;<KTSVG path='/media/icons/duotune/arrows/arr095.svg' className='svg-icon-2' />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.type == 9)) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Subreddit Name')}</label>
                        <div className='col-lg-8 fv-row'>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={LanguageHelp('Subreddit Name')}
                            {...formik.getFieldProps('searchQuery')}
                          />
                          {formik.touched.searchQuery && formik.errors.searchQuery && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Queries to search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            options={optionsSearchQueryList}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several text(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The texts to be searched must be at least one, and the number of letters of the texts must be at least 3.")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {((channel.type === 3) || (channel.type === 5)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Url to search')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Url to search')}
                          {...formik.getFieldProps('searchUrl')}
                        />
                        {formik.touched.searchUrl && formik.errors.searchUrl && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchUrl}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.type == 26)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Facebook Username')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Facebook Username')}
                          {...formik.getFieldProps('searchQuery')}
                        />
                        {formik.touched.searchQuery && formik.errors.searchQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.type == 7) || (formik.values.type == 10)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Instagram Username')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Instagram Username')}
                          {...formik.getFieldProps('searchQuery')}
                        />
                        {formik.touched.searchQuery && formik.errors.searchQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {((channel.type === 8)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Youtube Channel Id')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Youtube Channel Id')}
                          {...formik.getFieldProps('searchQuery')}
                        />
                        {formik.touched.searchQuery && formik.errors.searchQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Texts to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            options={optionsSearchQueryList}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several text(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}

                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The texts to be searched must be at least one, and the number of letters of the texts must be at least 3.")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {((channel.type === 20)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Search Query')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Search Query')}
                          {...formik.getFieldProps('searchQuery')}
                        />
                        {formik.touched.searchQuery && formik.errors.searchQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {(formik.values.type == 11) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Blocked TikTok Usernames')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several username(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryExceptionList')}
                            onChange={(searchQueryExceptionList) => formik.setFieldValue('searchQueryExceptionList', searchQueryExceptionList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryExceptionList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("You must add at least one username to block the search. You must enter your own username. Usernames must be at least 3 letters and contain only lowercase letters, numbers and _")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Hashtag to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            options={optionsSearchQueryList}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several hashtag(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The hashtags to be searched must be at least one, and the number of letters of the hashtags must be at least 3. Hashtags must be start with '#' character")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.type == 11) || (formik.values.type == 12)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('TikTok Username')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('TikTok Username')}
                          {...formik.getFieldProps('searchQuery')}
                        />
                        {formik.touched.searchQuery && formik.errors.searchQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {(formik.values.type == 2) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Twitter Username')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Twitter Username')}
                          {...formik.getFieldProps('searchQuery')}
                        />
                        {formik.touched.searchQuery && formik.errors.searchQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                          </div>
                        )}
                      </div>
                      <div className='form-text'>
                        {LanguageHelp('Your username can only contain lowercase letters, numbers, \".\" and \"_\"')}
                      </div>
                    </div>
                  </div>
                }

                {((formik.values.type === 2) || (formik.values.type === 3) || (formik.values.type == 5) || (formik.values.type === 7) || (formik.values.type === 8) || (channel.type === 9) || (formik.values.type == 10) || (formik.values.type == 11) || (formik.values.type == 12) || (formik.values.type == 13) || (formik.values.type == 14) || (formik.values.type == 20) || (formik.values.type == 202) || (formik.values.type == 26)) &&
                  <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Data Retrieval Start Date')}</label>
                    <div className='col-lg-8 fv-row'>
                      <div
                        className='btn btn-icon btn-active-color-primary w-40px h-40px me-3' style={{ backgroundColor: mode === 'light' ? "#f5f8fa" : "#1b1b29", marginBottom: "4px" }}
                        onClick={(date) => formik.setFieldValue('dataRetrievalStartDate', null)}
                      >
                        <KTSVG path='/media/icons/duotune/abstract/abs012.svg' className=' svg-icon-1' style={{ filter: mode === 'light' ? "brightness(100%)" : "brightness(200%)" }} />
                      </div>
                      <DatePicker
                        // showIcon
                        locale={lang.selectedLang == "tr" ? "tr-TR" : "en-US"}
                        className='form-select form-select-solid form-select-lg'
                        dateFormat={lang.selectedLang == "tr" ? "dd.MM.yyyy" : "MM.dd.yyyy"}
                        selected={formik.values.dataRetrievalStartDate}
                        // preventOpenOnFocus={true}
                        // maxDate={new Date()}
                        showYearDropdown
                        scrollableYearDropdown
                        yearDropdownItemNumber={50}
                        // isClearable 
                        placeholderText={LanguageHelp('Select a date...')}
                        onChange={(date) => formik.setFieldValue('dataRetrievalStartDate', date)}
                      />
                    </div>
                  </div>
                }

                {((formik.values.type === 2) || (formik.values.type === 7) || (formik.values.type === 8) || (channel.type === 9) || (formik.values.type == 10) || (formik.values.type == 11) || (formik.values.type == 12) || (formik.values.type == 13) || (formik.values.type == 14) || (formik.values.type == 20) || (formik.values.type == 202) || (formik.values.type == 26)) &&
                  <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Language Restriction')}</label>
                    <div className='col-lg-8 fv-row'>
                      <select
                        className='form-select form-select-solid form-select-lg'
                        {...formik.getFieldProps('language')}
                      >
                        <option value=''>{LanguageHelp('Select a Language...')}</option>
                        <option value='en'>English</option>
                        <option value='tr'>Türkçe - Turkish</option>
                        <option value='id'>Bahasa Indonesia - Indonesian</option>
                        <option value='msa'>Bahasa Melayu - Malay</option>
                        <option value='ca'>Català - Catalan</option>
                        <option value='cs'>Čeština - Czech</option>
                        <option value='da'>Dansk - Danish</option>
                        <option value='de'>Deutsch - German</option>
                        <option value='en'>English</option>
                        <option value='en-gb'>English UK - British English</option>
                        <option value='es'>Español - Spanish</option>
                        <option value='fil'>Filipino</option>
                        <option value='fr'>Français - French</option>
                        <option value='ga'>Gaeilge - Irish (beta)</option>
                        <option value='gl'>Galego - Galician (beta)</option>
                        <option value='hr'>Hrvatski - Croatian</option>
                        <option value='it'>Italiano - Italian</option>
                        <option value='hu'>Magyar - Hungarian</option>
                        <option value='nl'>Nederlands - Dutch</option>
                        <option value='no'>Norsk - Norwegian</option>
                        <option value='pl'>Polski - Polish</option>
                        <option value='pt'>Português - Portuguese</option>
                        <option value='ro'>Română - Romanian</option>
                        <option value='sk'>Slovenčina - Slovak</option>
                        <option value='fi'>Suomi - Finnish</option>
                        <option value='sv'>Svenska - Swedish</option>
                        <option value='vi'>Tiếng Việt - Vietnamese</option>
                        <option value='tr'>Türkçe - Turkish</option>
                        <option value='el'>Ελληνικά - Greek</option>
                        <option value='bg'>Български език - Bulgarian</option>
                        <option value='ru'>Русский - Russian</option>
                        <option value='sr'>Српски - Serbian</option>
                        <option value='uk'>Українська мова - Ukrainian</option>
                        <option value='he'>עִבְרִית - Hebrew</option>
                        <option value='ur'>اردو - Urdu (beta)</option>
                        <option value='ar'>العربية - Arabic</option>
                        <option value='fa'>فارسی - Persian</option>
                        <option value='mr'>मराठी - Marathi</option>
                        <option value='hi'>हिन्दी - Hindi</option>
                        <option value='bn'>বাংলা - Bangla</option>
                        <option value='gu'>ગુજરાતી - Gujarati</option>
                        <option value='ta'>தமிழ் - Tamil</option>
                        <option value='kn'>ಕನ್ನಡ - Kannada</option>
                        <option value='th'>ภาษาไทย - Thai</option>
                        <option value='ko'>한국어 - Korean</option>
                        <option value='ja'>日本語 - Japanese</option>
                        <option value='zh-cn'>简体中文 - Simplified Chinese</option>
                        <option value='zh-tw'>繁體中文 - Traditional Chinese</option>
                      </select>

                    </div>
                    <div className='form-text'>
                      {LanguageHelp('Allows you to see data in the selected language only. If you do not want to impose restrictions, you can leave it blank.')}
                    </div>
                    <div className='form-text'>
                      {LanguageHelp('You will continue to pull content outside of this language and you will be charged for this content, but you will not see it. There will be no extra data collection and fees for platforms that offer language search.')}
                    </div>
                  </div>
                }

                {((formik.values.type == 2) || (formik.values.type == 7) || (formik.values.type == 8) || (formik.values.type == 11) || (formik.values.type == 12) || (formik.values.type == 13) || (formik.values.type == 14) || (formik.values.type == 26)) &&
                  <div>
                    <div className='col-lg-8 fv-row mb-7'>
                      <div className='form-check form-check-solid fv-row'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          {...formik.getFieldProps('isGetAccountSharings')}
                          checked={formik.values.isGetAccountSharings}
                          onChange={formik.handleChange}
                        />
                        <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isGetAccountSharings'>
                          {LanguageHelp('Take the shares too.')}
                        </label>
                      </div>
                      {formik.touched.isGetAccountSharings && formik.errors.isGetAccountSharings && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.isGetAccountSharings}</div>
                        </div>
                      )}

                    </div>
                  </div>

                }
                {((formik.values.type === 2) || (formik.values.type == 7) || (formik.values.type == 8) || (formik.values.type == 11) || (formik.values.type == 12) || (formik.values.type == 13) || (formik.values.type == 14) || (formik.values.type == 26)) &&
                  <div>
                    <div className='col-lg-8 fv-row mb-7'>
                      <div className='form-check form-check-solid fv-row'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          {...formik.getFieldProps('isGetAccountSharingsComments')}
                          checked={formik.values.isGetAccountSharingsComments}
                          onChange={formik.handleChange}
                        />
                        <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isGetAccountSharingsComments'>
                          {LanguageHelp('Take the comments too.')}
                        </label>
                      </div>
                      {formik.touched.isGetAccountSharingsComments && formik.errors.isGetAccountSharingsComments && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.isGetAccountSharingsComments}</div>
                        </div>
                      )}

                    </div>
                  </div>

                }
                {((formik.values.type === 2) || (formik.values.type === 3) || (formik.values.type == 5) || (formik.values.type === 7) || (formik.values.type === 8) || (channel.type === 9) || (formik.values.type == 10) || (formik.values.type == 11) || (formik.values.type == 12) || (formik.values.type == 13) || (formik.values.type == 14) || (formik.values.type == 20) || (formik.values.type == 202) || (formik.values.type == 26)) &&
                  <div>
                    <div className='col-lg-8 fv-row'>
                      <div className='form-check form-check-solid fv-row'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          {...formik.getFieldProps('isAutoSearch')}
                          checked={formik.values.isAutoSearch}
                          onChange={formik.handleChange}
                        />
                        <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isAutoSearch'>
                          {LanguageHelp('I want daily data collection.')}
                        </label>
                      </div>
                      {formik.touched.isAutoSearch && formik.errors.isAutoSearch && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.isAutoSearch}</div>
                        </div>
                      )}

                    </div>
                    <div className='mt-6'>
                      <div className='col-lg-8 fv-row'>
                        <div className='form-check form-check-solid fv-row'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            {...formik.getFieldProps('isCompetitor')}
                            checked={formik.values.isCompetitor}
                            onChange={formik.handleChange}
                          />
                          <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isCompetitor'>
                            {LanguageHelp('This is a competitor channel.')}
                          </label>
                        </div>
                        {formik.touched.isCompetitor && formik.errors.isCompetitor && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.isCompetitor}</div>
                          </div>
                        )}
                      </div>
                      {(formik.values.isCompetitor == true) &&
                        <div className='fv-row mb-7'>
                          <div className='row mb-6'>
                            <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Competitor Name')}</label>
                            <div className='col-lg-8 fv-row'>
                              <input
                                placeholder={LanguageHelp('Competitor Name')}
                                {...formik.getFieldProps('competitorName')}
                                type='text'
                                name='competitorName'
                                className={clsx('form-control form-control-lg form-control-solid')}
                                autoComplete='off'
                                disabled={formik.isSubmitting}
                              />
                              {formik.touched.competitorName && formik.errors.competitorName && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.competitorName}</span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                        </div>
                      }
                    </div>
                  </div>
                }

                {(formik.values.type == 6) &&
                  <div>
                    
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Bot Name')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder='SenseBot'
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetBotName')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetBotName', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('WidgetBotName'), true)}
                        />
                        {isCustomFieldTouched('WidgetBotName') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetBotName') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Subtitle')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Online now')}
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetSubtitle')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetSubtitle', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('WidgetSubtitle'), true)}
                        />
                        {isCustomFieldTouched('WidgetSubtitle') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetSubtitle') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Avatar Image URL')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder='https://aisenseus.net/images/author/author1.jpg'
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetImage')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetImage', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('WidgetImage'), true)}
                        />
                        {isCustomFieldTouched('WidgetImage') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetImage') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Language')}</label>
                      <div className='col-lg-8 fv-row'>
                        <select
                          className='form-select form-select-solid form-select-lg'
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetLocale') || 'tr'}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetLocale', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('WidgetLocale'), true)}
                        >
                          <option value='tr'>{LanguageHelp('Turkish')}</option>
                          <option value='en'>{LanguageHelp('English')}</option>
                        </select>
                        {isCustomFieldTouched('WidgetLocale') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetLocale') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('Bu alan zorunludur.')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Widget Position')}</label>
                      <div className='col-lg-8 fv-row'>
                        <select
                          className='form-select form-select-solid form-select-lg'
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetPosition') || 'right'}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetPosition', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('WidgetPosition'), true)}
                        >
                          <option value='right'>{LanguageHelp('Right')}</option>
                          <option value='left'>{LanguageHelp('Left')}</option>
                        </select>
                        {isCustomFieldTouched('WidgetPosition') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetPosition') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('Bu alan zorunludur.')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Brand Color')}</label>
                      <div className='col-lg-8 fv-row d-flex align-items-center gap-3'>
                        <input
                          type='color'
                          style={{ width: 42, height: 42, padding: 2, border: 'none', background: 'none', cursor: 'pointer' }}
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetBrandColor') || '#13c4a1'}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetBrandColor', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('WidgetBrandColor'), true)}
                        />
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          style={{ maxWidth: 120 }}
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetBrandColor') || '#13c4a1'}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetBrandColor', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('WidgetBrandColor'), true)}
                        />
                        {isCustomFieldTouched('WidgetBrandColor') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetBrandColor') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('Bu alan zorunludur.')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Welcome Message')}</label>
                      <div className='col-lg-8 fv-row'>
                        <textarea className='form-control form-control-lg form-control-solid' rows={3}
                          placeholder={LanguageHelp('Welcome message shown when chat opens')}
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetWelcomeMessage')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetWelcomeMessage', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('WidgetWelcomeMessage'), true)}
                        />
                        {isCustomFieldTouched('WidgetWelcomeMessage') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'WidgetWelcomeMessage') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('Bu alan zorunludur.')}</div>
                          </div>
                        )}
                      </div>
                    </div>

                    {renderCommonChatbotPromptSection('channel', true)}

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Expiration Date')}</label>
                      <label className='col-lg-8 col-form-label fv-row'>
                        {formatDate(channelForEdit.tokenExpirationDate, lang.selectedLang)}
                      </label>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('New Expiration Time')}</label>
                      <div className='col-lg-8 fv-row'>
                        <select
                          className='form-select form-select-solid form-select-lg'
                          {...formik.getFieldProps('expirationTime')}
                          onChange={formik.handleChange}
                        >
                          <option value=''>{LanguageHelp('Select a time to update the expiration date')}</option>
                          <option value='limitless'>{LanguageHelp('Limitless')}</option>
                          <option value='1 month'>{LanguageHelp('1 month')}</option>
                          <option value='3 month'>{LanguageHelp('3 month')}</option>
                          <option value='6 month'>{LanguageHelp('6 month')}</option>
                          <option value='1 year'>{LanguageHelp('1 year')}</option>
                          <option value='2 year'>{LanguageHelp('2 year')}</option>
                          <option value='3 year'>{LanguageHelp('3 year')}</option>
                        </select>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <div className='notice d-flex bg-light-success rounded border-warning border border-dashed mb-6 p-6'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen044.svg'
                          className='svg-icon-2tx svg-icon-success me-4'
                        />

                        <div className='d-flex flex-stack flex-grow-1'>
                          <div className='fw-bold'>
                            <div className='fs-6 text-gray-600'>
                              {LanguageHelp('To run the Chatbot, simply add the following codes to your web page.')}
                            </div>
                            <div className='fs-7 col-form-label' style={{ wordBreak: 'break-all' }}>
                              {'<script src="https://aisenseus.net/chatbot-embed.js"></script>\n<script>\n  window.AISenseUsChatbotConfig = {\n    token: "' + channelForEdit.token + '"\n  };\n</script>'}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {isConversationReviewAnalysisChannelType(Number(formik.values.type)) &&
                  <div className='row mb-6'>
                    <div className='col-lg-8 fv-row'>
                      <div className='form-check form-check-solid fv-row'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          {...formik.getFieldProps('isAutoAnalysis')}
                          checked={formik.values.isAutoAnalysis}
                          onChange={formik.handleChange}
                        />
                        <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isAutoAnalysis'>
                          {LanguageHelp('I want automatic conversation analysis.')}
                        </label>
                      </div>
                    </div>
                  </div>
                }

                {(formik.values.type == 100) &&
                  <div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Expiration Date')}</label>
                      <label className='col-lg-8 col-form-label fv-row'>
                        {formatDate(channelForEdit.tokenExpirationDate, lang.selectedLang)}
                      </label>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('New Expiration Time')}</label>
                      <div className='col-lg-8 fv-row'>
                        <select
                          className='form-select form-select-solid form-select-lg'
                          {...formik.getFieldProps('expirationTime')}
                          onChange={formik.handleChange}
                        >
                          <option value=''>{LanguageHelp('Select a time to update the expiration date')}</option>
                          <option value='limitless'>{LanguageHelp('Limitless')}</option>
                          <option value='1 month'>{LanguageHelp('1 month')}</option>
                          <option value='3 month'>{LanguageHelp('3 month')}</option>
                          <option value='6 month'>{LanguageHelp('6 month')}</option>
                          <option value='1 year'>{LanguageHelp('1 year')}</option>
                          <option value='2 year'>{LanguageHelp('2 year')}</option>
                          <option value='3 year'>{LanguageHelp('3 year')}</option>
                        </select>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Token')}</label>
                      <label className='col-lg-8 col-form-label fv-row'>
                        {channelForEdit.token}
                      </label>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Webhook Url')}</label>
                      <label className='col-lg-8 col-form-label fv-row'>
                        https://api.aisenseus.net/api/Conversation/MeetTranscriptionAnalyser
                      </label>
                    </div>

                    <div className='row mb-6'>
                      <div className='notice d-flex bg-light-success rounded border-warning border border-dashed mb-6 p-6'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen044.svg'
                          className='svg-icon-2tx svg-icon-success me-4'
                        />
                        <div className='d-flex flex-stack flex-grow-1'>
                          <div className='fw-bold'>
                            <div className='fs-6 text-gray-600'>
                              <div>
                                {LanguageHelp('Click on the link to the plugin that you can use with Chrome, Edge and Firefox.')}
                                <a href='https://chromewebstore.google.com/detail/aisenseus/cbojomnehgiadpclibfpidkipekmeldd' target='_blank' className='text-gray-800 text-hover-primary' >
                                  &nbsp;<KTSVG path='/media/icons/duotune/arrows/arr095.svg' className='svg-icon-2' />
                                </a>
                              </div>
                              <div>{LanguageHelp('After installing the extension, click the pop-up, open "Settings", enter the webhook URL and the token from abovee and save it to start using.')}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                {(Number(formik.values.type) == 107) &&
                  <div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Webhook Url')}</label>
                      <div className='col-lg-8 fv-row'>
                        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            value={'https://api.aisenseus.net/api/Webhook/WhatsApp'}
                            readOnly
                            style={{ flex: 1, backgroundColor: '#f5f8fa', cursor: 'pointer' }}
                            tabIndex={-1}
                          />
                          <button
                            type='button'
                            className='btn btn-icon btn-icon-lg btn-light-primary'
                            title={LanguageHelp('Panoya kopyala')}
                            onClick={() => {
                              navigator.clipboard.writeText('https://api.aisenseus.net/api/Webhook/WhatsApp')
                              toast.success(LanguageHelp('Panoya kopyalandı'))
                            }}
                          >
                            <i className='fas fa-copy'></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('WhatsApp Verify Token')}</label>
                      <div className='col-lg-8 fv-row'>
                        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={LanguageHelp('WhatsApp Verify Token')}
                            value={(() => {
                              const auth = authHelper.getAuth()
                              if (auth && auth.result && auth.result.companyId) {
                                return auth.result.companyId
                              }
                              return ''
                            })()}
                            readOnly
                            style={{ flex: 1, backgroundColor: '#f5f8fa', cursor: 'pointer' }}
                          />
                          <button
                            type='button'
                            className='btn btn-icon btn-icon-lg btn-light-primary'
                            title={LanguageHelp('Panoya kopyala')}
                            onClick={() => {
                              const auth = authHelper.getAuth()
                              if (auth && auth.result && auth.result.companyId) {
                                navigator.clipboard.writeText(auth.result.companyId)
                                toast.success(LanguageHelp('Panoya kopyalandı'))
                              }
                            }}
                          >
                            <i className='fas fa-copy'></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('WhatsApp Access Token')}</label>
                      <div className='col-lg-8 fv-row'> 
                        <input 
                          type='text'
                          className='form-control form-control-lg form-control-solid' 
                          placeholder={LanguageHelp('WhatsApp Access Token')}
                          value={getCustomFieldValue(formik.values.channelCustomFieldList, 'WhatsappAccessToken')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setCustomFieldValue(formik.values.channelCustomFieldList, 'WhatsappAccessToken', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('WhatsappAccessToken'), true)}
                        />
                        {isCustomFieldTouched('WhatsappAccessToken') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'WhatsappAccessToken') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('WhatsApp Phone Number Id')}</label>
                      <div className='col-lg-8 fv-row'> 
                        <input type='text' className='form-control form-control-lg form-control-solid' placeholder={LanguageHelp('WhatsApp Phone Number Id')}
                          value={getCustomFieldValue(formik.values.channelCustomFieldList, 'WhatsappPhoneNumberId')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setCustomFieldValue(formik.values.channelCustomFieldList, 'WhatsappPhoneNumberId', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('WhatsappPhoneNumberId'), true)}
                        />
                        {isCustomFieldTouched('WhatsappPhoneNumberId') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'WhatsappPhoneNumberId') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>WhatsApp Business Account Id (WABA)</label>
                      <div className='col-lg-8 fv-row'> 
                        <input type='text' className='form-control form-control-lg form-control-solid' placeholder='WhatsApp Business Account Id (WABA)'
                          value={getCustomFieldValue(formik.values.channelCustomFieldList, 'WhatsappBusinessAccountId')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setCustomFieldValue(formik.values.channelCustomFieldList, 'WhatsappBusinessAccountId', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('WhatsappBusinessAccountId'), true)}
                        />
                        {isCustomFieldTouched('WhatsappBusinessAccountId') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'WhatsappBusinessAccountId') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>WhatsApp App Secret</label>
                      <div className='col-lg-8 fv-row'> 
                        <input type='text' className='form-control form-control-lg form-control-solid' placeholder='WhatsApp App Secret'
                          value={getCustomFieldValue(formik.values.channelCustomFieldList, 'WhatsappAppSecret')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setCustomFieldValue(formik.values.channelCustomFieldList, 'WhatsappAppSecret', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('WhatsappAppSecret'), true)}
                        />
                        {isCustomFieldTouched('WhatsappAppSecret') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'WhatsappAppSecret') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    {renderCommonChatbotPromptSection('custom')}
                  </div>
                }

                {(Number(formik.values.type) == 104) &&
                  <div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Webhook Url')}</label>
                      <div className='col-lg-8 fv-row'>
                        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            value={(() => {
                              const auth = authHelper.getAuth();
                              if (auth && auth.result && auth.result.companyId) {
                                return 'https://api.aisenseus.net/api/Webhook/Twitter?verifyToken=' + auth.result.companyId + '&verifySecret=' + getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterConsumerSecretKey');
                              }
                              return '';
                            })()}
                            readOnly
                            style={{ flex: 1, backgroundColor: '#f5f8fa', cursor: 'pointer' }}
                            tabIndex={-1}
                          />
                          <button
                            type='button'
                            className='btn btn-icon btn-icon-lg btn-light-primary'
                            title={LanguageHelp('Panoya kopyala')}
                            onClick={() => {
                              const auth = authHelper.getAuth();
                              if (auth && auth.result && auth.result.companyId) {
                                navigator.clipboard.writeText('https://api.aisenseus.net/api/Webhook/Twitter?verifyToken=' + auth.result.companyId + '&verifySecret=' + getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterConsumerSecretKey'))
                                toast.success(LanguageHelp('Panoya kopyalandı'))
                              }
                            }}
                          >
                            <i className='fas fa-copy'></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Twitter Consumer Key')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Twitter Consumer Key')}
                          value={getCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterConsumerKey')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterConsumerKey', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('TwitterConsumerKey'), true)}
                        />
                        {isCustomFieldTouched('TwitterConsumerKey') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterConsumerKey') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Twitter Consumer Secret Key')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Twitter Consumer Secret Key')}
                          value={getCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterConsumerSecretKey')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterConsumerSecretKey', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('TwitterConsumerSecretKey'), true)}
                        />
                        {isCustomFieldTouched('TwitterConsumerSecretKey') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterConsumerSecretKey') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Twitter Access Token')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Twitter Access Token')}
                          value={getCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterAccessToken')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterAccessToken', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('TwitterAccessToken'), true)}
                        />
                        {isCustomFieldTouched('TwitterAccessToken') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterAccessToken') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Twitter Access Token Secret')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Twitter Access Token Secret')}
                          value={getCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterAccessTokenSecret')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterAccessTokenSecret', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('TwitterAccessTokenSecret'), true)}
                        />
                        {isCustomFieldTouched('TwitterAccessTokenSecret') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterAccessTokenSecret') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Twitter Webhook Environment Name')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Twitter Webhook Environment Name')}
                          value={getCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterWebhookEnviromentName')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterWebhookEnviromentName', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('TwitterWebhookEnviromentName'), true)}
                        />
                        {isCustomFieldTouched('TwitterWebhookEnviromentName') && !getCustomFieldValue(formik.values.channelCustomFieldList, 'TwitterWebhookEnviromentName') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    {renderCommonChatbotPromptSection('custom')}
                  </div>
                }
                {(Number(formik.values.type) == 106) &&
                  <div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Webhook Url')}</label>
                      <div className='col-lg-8 fv-row'>
                        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            value={'https://api.aisenseus.net/api/Webhook/Facebook'}
                            readOnly
                            style={{ flex: 1, backgroundColor: '#f5f8fa', cursor: 'pointer' }}
                            tabIndex={-1}
                          />
                          <button
                            type='button'
                            className='btn btn-icon btn-icon-lg btn-light-primary'
                            title={LanguageHelp('Panoya kopyala')}
                            onClick={() => {
                              navigator.clipboard.writeText('https://api.aisenseus.net/api/Webhook/Facebook')
                              toast.success(LanguageHelp('Panoya kopyalandı'))
                            }}
                          >
                            <i className='fas fa-copy'></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Facebook Verify Token')}</label>
                      <div className='col-lg-8 fv-row'>
                        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={LanguageHelp('Facebook Verify Token')}
                            value={(() => {
                              const auth = authHelper.getAuth()
                              if (auth && auth.result && auth.result.companyId) {
                                return auth.result.companyId
                              }
                              return ''
                            })()}
                            readOnly
                            style={{ flex: 1, backgroundColor: '#f5f8fa', cursor: 'pointer' }}
                            tabIndex={-1}
                          />
                          <button
                            type='button'
                            className='btn btn-icon btn-icon-lg btn-light-primary'
                            title={LanguageHelp('Panoya kopyala')}
                            onClick={() => {
                              const auth = authHelper.getAuth()
                              if (auth && auth.result && auth.result.companyId) {
                                navigator.clipboard.writeText(auth.result.companyId)
                                toast.success(LanguageHelp('Panoya kopyalandı'))
                              }
                            }}
                          >
                            <i className='fas fa-copy'></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Facebook Page ID')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Facebook Page ID')}
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'FacebookPageId')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'FacebookPageId', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('FacebookPageId'), true)}
                        />
                        {isCustomFieldTouched('FacebookPageId') && !getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'FacebookPageId') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Facebook Page Access Token')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Facebook Page Access Token')}
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'FacebookPageAccessToken')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'FacebookPageAccessToken', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('FacebookPageAccessToken'), true)}
                        />
                        {isCustomFieldTouched('FacebookPageAccessToken') && !getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'FacebookPageAccessToken') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Facebook App Secret')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Facebook App Secret (for X-Hub-Signature-256 validation)')}
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'FacebookAppSecret')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'FacebookAppSecret', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('FacebookAppSecret'), true)}
                        />
                        {isCustomFieldTouched('FacebookAppSecret') && !getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'FacebookAppSecret') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    {renderCommonChatbotPromptSection('channel')}
                  </div>
                }
                {(Number(formik.values.type) == 105) &&
                  <div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Webhook Url')}</label>
                      <div className='col-lg-8 fv-row'>
                        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                          <input type='text' className='form-control form-control-lg form-control-solid' value={'https://api.aisenseus.net/api/Webhook/Instagram'} readOnly style={{ flex: 1, backgroundColor: '#f5f8fa', cursor: 'pointer' }} tabIndex={-1} />
                          <button type='button' className='btn btn-icon btn-icon-lg btn-light-primary' title={LanguageHelp('Panoya kopyala')} onClick={() => { navigator.clipboard.writeText('https://api.aisenseus.net/api/Webhook/Instagram'); toast.success(LanguageHelp('Panoya kopyalandı')) }}>
                            <i className='fas fa-copy'></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Instagram Verify Token')}</label>
                      <div className='col-lg-8 fv-row'>
                        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={LanguageHelp('Instagram Verify Token')}
                            value={(() => {
                              const auth = authHelper.getAuth()
                              if (auth && auth.result && auth.result.companyId) {
                                return auth.result.companyId
                              }
                              return ''
                            })()}
                            readOnly
                            style={{ flex: 1, backgroundColor: '#f5f8fa', cursor: 'pointer' }}
                            tabIndex={-1}
                          />
                          <button
                            type='button'
                            className='btn btn-icon btn-icon-lg btn-light-primary'
                            title={LanguageHelp('Panoya kopyala')}
                            onClick={() => {
                              const auth = authHelper.getAuth()
                              if (auth && auth.result && auth.result.companyId) {
                                navigator.clipboard.writeText(auth.result.companyId)
                                toast.success(LanguageHelp('Panoya kopyalandı'))
                              }
                            }}
                          >
                            <i className='fas fa-copy'></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Instagram Business Account ID')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Instagram Business Account ID')}
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'InstagramBusinessAccountId')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'InstagramBusinessAccountId', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('InstagramBusinessAccountId'), true)}
                        />
                        {isCustomFieldTouched('InstagramBusinessAccountId') && !getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'InstagramBusinessAccountId') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Instagram Page Access Token')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Instagram Page Access Token')}
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'InstagramPageAccessToken')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'InstagramPageAccessToken', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('InstagramPageAccessToken'), true)}
                        />
                        {isCustomFieldTouched('InstagramPageAccessToken') && !getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'InstagramPageAccessToken') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Instagram App Secret')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Instagram App Secret (for X-Hub-Signature-256 validation)')}
                          value={getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'InstagramAppSecret')}
                          onChange={e => {
                            formik.setFieldValue('channelCustomFieldList', setChannelCustomFieldValue(formik.values.channelCustomFieldList, 'InstagramAppSecret', e.target.value));
                          }}
                          onBlur={() => formik.setFieldTouched(getCustomFieldTouchedPath('InstagramAppSecret'), true)}
                        />
                        {isCustomFieldTouched('InstagramAppSecret') && !getChannelCustomFieldValue(formik.values.channelCustomFieldList, 'InstagramAppSecret') && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{LanguageHelp('This field is required')}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    {renderCommonChatbotPromptSection('channel')}
                  </div>
                }
              </div>
            </div>
            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <DeleteChannelModal functionDelete={functionDelete} id={id} />
              <button type='button' className='btn btn-danger' data-bs-toggle='modal' data-bs-target='#kt_modal_channel_delete'>
                {LanguageHelp('Delete')}
              </button>
              {/* Test button for chatbot channels */}
              {Number(formik.values.type) === 6 && formik.values.id && (
                <a
                  className='btn btn-info ms-3'
                  href={`https://aisenseus.net/chatbot-iframe-test.html?chatId=${encodeURIComponent(formik.values.id)}`}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ marginRight: 8 }}
                >
                  {LanguageHelp('Test Chatbot')}
                </a>
              )}
              <button type='submit' className='btn btn-primary ms-3' disabled={formik.isSubmitting || !formik.isValid}>
                {!loading && LanguageHelp('Save')}
                {loading && (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    {LanguageHelp('Please Wait...')}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </form>
        </div >
      </div >
    </div >
  )
}

export { ChannelForm }